export const USERS_FETCH_REQUEST = "USERS_FETCH_REQUEST";
export const USERS_FETCH_SUCCESS = "USERS_FETCH_SUCCESS";
export const USERS_FETCH_FAIL = "USERS_FETCH_FAIL";

export const USERS_CLEAR_ERROR = "USERS_CLEAR_ERROR";
